var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 564.035 564.035",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M480.416.011H84.655C38.095.011 0 38.105 0 84.666v394.703c0 46.56 38.095 84.655 84.655 84.655h394.703c46.56 0 84.655-38.095 84.655-84.655V84.666C565.071 38.105 526.977.011 480.416.011zm27.513 480.416a28.452 28.452 0 0 1-28.571 28.571H84.655a28.452 28.452 0 0 1-28.571-28.571V84.666a28.452 28.452 0 0 1 28.571-28.571h394.703a28.452 28.452 0 0 1 28.571 28.571zm-65.607-291.001c10.582-10.582 10.582-28.571 0-40.211-5.291-5.291-12.698-7.407-20.106-7.407-7.407 0-14.815 3.175-20.106 9.524L212.695 353.445l-49.735-52.909c-6.349-8.465-16.931-11.64-27.513-9.524s-19.047 9.524-21.164 20.106c-3.175 10.582 0 21.164 8.465 28.571l68.782 74.073c5.291 5.291 12.698 8.465 20.106 8.465 7.407 0 14.815-3.175 20.106-8.465z",
    clipRule: "evenodd",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishEntry);
export default __webpack_public_path__ + "static/media/finish-entry.56ec0aea72b4fc738e8a8cf62dabdcb6.svg";
export { ForwardRef as ReactComponent };